@if (formGroup()) {
    <sfx-form [isCompact]="true">
        <sfx-field
            label="project.version_description.description_label"
            [infoIcon]="descriptionInfoIcon"
        >
            <sfx-input
                [control]="formGroup().controls.versionDescription"
                [suffixIcon]="descriptionClearIcon"
                [mask]="lengthLimitMask"
                [unmask]="true"
            ></sfx-input>
        </sfx-field>

        <div class="version-info mad-text mad-text--xs">{{ 'project.confirm_clone.description' | translate }}</div>
    </sfx-form>
}
